export default "<canvas id=\"items-sold-chart\"></canvas>\r\n"